<template>
  <div class="contact" style="min-width:1440px;">
    <div class="contact_content">
      <!-- <div id="allmap"></div> -->
      <div class="container">
        <div class="content_top">
          <h1 v-if="chOrEn!='0'">联系我们</h1>
          <!-- <h4 v-if="chOrEn!='0'">生活因为您的来电而更美好</h4> -->
          <h1 v-if="chOrEn=='0'">Contact Us</h1>
          <!-- <h4 v-if="chOrEn=='0'">Life is better because of your call</h4> -->
        </div>
        <div v-if="chOrEn!='0'" style="font-size:20px;color:#FFFFFF;line-height: 26px;font-weight: bold;">联盟秘书处</div>
        <div v-else style="font-size:20px;color:#FFFFFF;line-height: 26px;font-weight: bold;">Union Secretariat:</div>
        <div v-if="chOrEn!='0'" class="one left"><span style="margin-right:10px;font-size:23px"><img src="../assets/img/baidian.png" style="color:#FFFFFF" alt /></span>联系电话：　<span style="font-weight:400">{{list.telphone}}</span></div>
        <div v-else class="one left"><span style="margin-right:10px;font-size:23px"><img src="../assets/img/baidian.png" style="color:#FFFFFF" alt /></span>Contact Number：　<span style="font-weight:400">{{list.telphone}}</span></div>
        <div v-if="chOrEn!='0'" class="one left"><span style="margin-right:10px;font-size:23px"><img src="../assets/img/baifan.png" style="color:#FFFFFF" alt /></span>邮箱：<span style="font-weight:400">{{list.email}}</span></div>
        <div v-else class="one left"><span style="margin-right:10px;font-size:23px"><img src="../assets/img/baifan.png" style="color:#FFFFFF" alt /></span>Email：　<span style="font-weight:400">{{list.email}}</span></div>
        <div v-if="chOrEn!='0'" class="one"><i class="el-icon-location-outline" style="margin-right:10px;font-size:23px"></i>地址：<span style="font-weight:400">{{list.address}}</span></div>
        <div v-else class="one"><i class="el-icon-location-outline" style="margin-right:10px;font-size:23px"></i>Address：　<span style="font-weight:400">{{list.address}}</span></div>
        <!-- <div v-if="chOrEn!='0'" class="one" style="margin-top:80px"><i class="el-icon-location-outline" style="margin-right:10px;font-size:23px"></i>联盟瑞士总部</div> -->
        <div v-if="chOrEn!='0'" class="one" style="margin-top:80px;font-size:20px">联盟瑞士总部</div>
        
        <div v-else class="one" style="margin-top:80px;font-size:20px">Union Headquarters in Switzerland：</div>
        <div v-if="chOrEn!='0'" class="one left"><span style="margin-right:10px;font-size:23px"><img src="../assets/img/baifan.png" style="color:#FFFFFF" alt /></span>邮箱：<span style="font-weight:400">{{list.zbEmail}}</span></div>
        <div v-else class="one left"><span style="margin-right:10px;font-size:23px"><img src="../assets/img/baifan.png" style="color:#FFFFFF" alt /></span>Email：　<span style="font-weight:400">{{list.zbEmail}}</span></div>
        <div v-if="chOrEn!='0'" class="one"><i class="el-icon-location-outline" style="margin-right:10px;font-size:23px"></i>地址：<span style="font-weight:400">{{list.zbAddr}}</span></div>
        <div v-else class="one"><i class="el-icon-location-outline" style="margin-right:10px;font-size:23px"></i>Address：<span style="font-weight:400">{{list.zbAddr}}</span></div>
        
      </div>
    </div>

  </div>
</template>

<script>

  import {contentget} from '../api/api'
export default {
  name: "contact",

  data() {
    return {
        list:{},
        chOrEn:sessionStorage.getItem('chOrEn'),
    };
  },
  created(){
    let navigationId = {
      "navigationId":"1"
    }
    contentget({...navigationId}).then(res=>{
      console.log(res.data.data.email4Apply,res)
      this.list=res.data.data
    })
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      // 百度地图API功能
      var map = new BMap.Map("allmap");
      var poi = new BMap.Point(125.340278, 43.828262);
      map.centerAndZoom(poi, 16);
      map.enableScrollWheelZoom();

      var content =
        '<div style="margin:0;line-height:20px;padding:2px;">' +
        '<img src="https://bkimg.cdn.bcebos.com/pic/3bf33a87e950352ac65c990fee0aecf2b21193131d28?x-bce-process=image/watermark,image_d2F0ZXIvYmFpa2UxMTY=,g_7,xp_5,yp_5" alt="" style="float:right;zoom:1;overflow:hidden;width:100px;height:100px;margin-left:3px;"/>' +
        "地址：长春世界雕塑园<br/>电话：(0431)85379019<br/>简介：长春世界雕塑园是4A级国家景区,是第一批国家重点公园" +
        "</div>";

      //创建检索信息窗口对象
      var searchInfoWindow = null;
      searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
        title: "长春世界雕塑园", //标题
        width: 290, //宽度
        height: 105, //高度
        panel: "panel", //检索结果面板
        enableAutoPan: true, //自动平移
        searchTypes: [
          BMAPLIB_TAB_SEARCH, //周边检索
          BMAPLIB_TAB_TO_HERE, //到这里去
          BMAPLIB_TAB_FROM_HERE, //从这里出发
        ],
      });
      var marker = new BMap.Marker(poi); //创建marker对象
      marker.enableDragging(); //marker可拖拽
      marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
      marker.addEventListener("click", function (e) {
        searchInfoWindow.open(marker);
      });
      map.addOverlay(marker); //在地图中添加marker
      //样式1
      var searchInfoWindow1 = new BMapLib.SearchInfoWindow(map, "信息框1内容", {
        title: "信息框1", //标题
        panel: "panel", //检索结果面板
        enableAutoPan: true, //自动平移
        searchTypes: [
          BMAPLIB_TAB_FROM_HERE, //从这里出发
          BMAPLIB_TAB_SEARCH, //周边检索
        ],
      });
      function openInfoWindow1() {
        searchInfoWindow1.open(new BMap.Point(125.340278, 43.828262));
      }
      //样式2
      var searchInfoWindow2 = new BMapLib.SearchInfoWindow(map, "信息框2内容", {
        title: "信息框2", //标题
        panel: "panel", //检索结果面板
        enableAutoPan: true, //自动平移
        searchTypes: [
          BMAPLIB_TAB_SEARCH, //周边检索
        ],
      });
      function openInfoWindow2() {
        searchInfoWindow2.open(new BMap.Point(125.340278, 43.828262));
      }
      //样式3
      var searchInfoWindow3 = new BMapLib.SearchInfoWindow(map, "信息框3内容", {
        title: "信息框3", //标题
        width: 290, //宽度
        height: 40, //高度
        panel: "panel", //检索结果面板
        enableAutoPan: true, //自动平移
        searchTypes: [],
      });
      function openInfoWindow3() {
        searchInfoWindow3.open(new BMap.Point(125.340278, 43.828262));
      }
    },
  },
};
</script>

<style lang="less" scoped>
.left{
  display: flex;
  justify-content:  flex-start;
  align-items: center;
}
.one{
  margin-top:28px;font-size:18px;color:#FFFFFF;line-height: 24px;font-weight: bold;
}
.two{
  margin-top:28px;font-size:16px;color:#FFFFFF;line-height: 24px;font-weight: bold;
}
.contact_content {
  width: 100%;
  background: url("../assets/img/8.png") no-repeat;
  background-size: 100% 100%;
  #allmap {
    width: 100%;
    height: 755px;
  }
  .container {
    padding: 0 0 160px;
    height: 880px;
    color: #010101;
    .content_top {
      // background: url("../assets/img/contact us.png") no-repeat center 130px;
      text-align: left;
      color:#FFFFFF;
      padding: 160px 0 40px 0;
      h1 {
        font-size: 64px;
        line-height: 96px;
      }
      h4 {
        font-size: 24px;
        line-height: 38px;
      }
    }
    .content_bottom {
      width: 100%;
      height: 610px;
      border-radius: 10px;
      // background: url("../assets/img/contact_03.png") no-repeat;
      background-size: 100% 100%;
      padding-top: 70px;
      padding-left: 630px;
      .bottom_content {
        width: 412px;
        height: 468px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 15px;
        padding-top: 36px;
        padding-left: 40px;
        padding-right: 25px;
        .content_item {
          cursor: pointer;
          h3 {
            font-size: 20px;
            line-height: 32px;
          }
          margin-bottom: 5px;
        }
      }
    }
  }
}
dl,
dt,
dd,
ul,
li {
  margin: 0;
  padding: px0;
  list-style: none;
}
dt {
  font-size: 14px;
  font-family: "微软雅黑";
  font-weight: bold;
  border-bottom: 1px dotted #000;
  padding: 5px 0 5px 5px;
  margin: 5px 0;
}
dd {
  padding: 5px 0 0 5px;
}
li {
  line-height: 28px;
}
/deep/ .BMapLib_SearchInfoWindow .BMapLib_bubble_bottom {
  height: 18px !important;
}
</style>